/**
 * Created by devmaster on 7/14/2017 AD.
 */
import { createReducer } from '../utils';
import createConstants from '../constants';

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  statusText:''
};

export default createReducer (initialState, {
  [createConstants.LOGIN_USER_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticated: true,
      user:  payload.user,
      token: payload.token,
      statusText:'successfully logged in'
    });
  },
  [createConstants.LOGIN_USER_FAILURE]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticated: false,
      user: null,
      token: null,
      statusText: 'Authentication Error'
    });
  },
  [createConstants.LOGOUT_USER]: (state, payload) => {
    return Object.assign({}, state, {
      isAuthenticated: false,
      user: null,
      token: null,
      statusText: 'successfully logged out.'
    });
  }
})
